import useUrlParams from './useUrlParams'

interface QueryParam {
  isFeatureEnabled?: string
}

const useFeatureFlag: () => [boolean] = () => {
  const [urlParams] = useUrlParams<QueryParam>()
  const { isFeatureEnabled } = urlParams

  return [isFeatureEnabled === 'true']
}

export default useFeatureFlag
